import React from "react";

const HomeContent = () => {
  return (
    <section className="mb-20 rounded-lg bg-white p-8 shadow-md">
      <div className="mx-auto max-w-4xl space-y-6 text-gray-700">
        <h3 className="text-center text-3xl font-bold text-gray-800">
          Plan Printable Skadis Boards Before You Slice
        </h3>
        <p className="leading-7">
          Skadisfinity Layout is built for makers who print their own
          Skadis-compatible boards instead of guessing how many pieces will fit
          a wall, drawer, shelf, or workbench area. Enter the space you want to
          fill, choose the printer build volume, then compare the calculated
          board pieces and trim areas before committing filament and print time.
        </p>
        <p className="leading-7">
          The calculator focuses on practical layout decisions: how a
          240mm-by-240mm board breaks down, how smaller edge pieces reduce
          leftover spacer gaps, and when a printer profile changes the best
          board combination. The visual preview is intended to make those
          tradeoffs easy to inspect at a glance.
        </p>
        <div className="grid gap-6 md:grid-cols-3">
          <div>
            <h4 className="mb-2 font-semibold text-gray-900">
              Measure the space
            </h4>
            <p className="text-sm leading-6">
              Use the actual opening or wall area you want to cover, then
              choose inches or millimeters to match your measuring tools.
            </p>
          </div>
          <div>
            <h4 className="mb-2 font-semibold text-gray-900">
              Pick the print profile
            </h4>
            <p className="text-sm leading-6">
              Use the default profile for standard Skadisfinity boards or AU3D
              when you want the AU3D 20mm size table and hole-count labels.
            </p>
          </div>
          <div>
            <h4 className="mb-2 font-semibold text-gray-900">
              Check trim before printing
            </h4>
            <p className="text-sm leading-6">
              Review the preview for thin strips, spacer waste, and board count
              before exporting or modeling the final printable parts.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeContent;
